export const retryButtonText = "nNnTNc";
export default {retryButtonText};